import { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { withTranslation, useTranslation, TFunction } from "react-i18next";
import Image from "react-bootstrap/Image";
import { isMobile } from "react-device-detect";
import JobDetailsV2 from "src/components/common/MainContent/JobDescription/JobDetailsV2";
import { postJobApplicationFavoriteEmail } from "src/redux/userAction/applyFavEmail/action";
import { detectJobCardClick } from "src/redux/jobDetails/action";
import Banner from "src/components/common/Banner/HeroBanner";
import config from "src/config";
import { fetchRecommendedJobs } from "src/redux/jobs/SearchCrossCountry/action";
import { getAccessToken } from "axios-jwt";
import imageResolution from "src/services/ImageResolution";
import { jobDetailType, facilityCustomContentResult } from "src/components/common/MainContent/JobResults/common/index";
import { graphqlRequest as request } from "src/services/GraphQL/GraphQL";
import { GET_FACILITY_CUSTOM_CONTENT, GET_JOB_DETAILS } from "src/services/GraphQL/graph.query";
const facilityModalApplicable = config.FACILITY_MODAL === "true";
import { RecommendedJobsSourceTypes } from "src/types/receommendedJobsSource";
import getCandidateInformation, { OnboardingInfo } from "src/components/common/CandidateInformation/CandidateInformation";
import { JobCardProps } from "src/components/common/MainContent/v3/job-card/JobCard";
import JobSlider from "src/components/common/MainContent/v3/job-card/slider/JobSlider";
import JobCardList from "src/components/common/MainContent/v3/job-card/list/JobCardList"
import { SIMILAR_JOBS,CROWD_SOURCING_JOBS,HOMEPAGE } from "src/constants/campaigns_constants";
import clsx from "clsx";
import NewChevronRightIcon from "src/imagesV2/NewChevronRightIcon.svg";

interface RecommendedJobsData {
  sort: string;
  companyId: string | null;
  size: string | undefined;
  candidateId: string;
  candidateInformation: any;
}

interface DetectJobCardClick {
  isCardClicked: boolean;
  job: jobDetailType;
  isRecommended: boolean;
  campaignCode: string | null;
  sourceType: string | null;
  companyId: string | null;
  size: string | undefined;
  candidateInformation: any;
  candidateId: string;
}
interface SimilarJobs {
  page: {
    size: number
    number: number
    totalPages: number
    totalElements: any
  }
  _embedded: {
    results: any
    tags: Array<any>
    resultOfType: any
    aggregations: any
  }
}

interface CollaboratedJobs {
  page: {
    size: number
    number: number
    totalPages: number
    totalElements: any
  }
  _embedded: {
    results: any
    tags: Array<any>
    resultOfType: any
    aggregations: any
  }
}

interface ViewedJob {
  jobId: string | null;
  userId: number;
  action: string;
  request: {
    isActive: boolean;
  };
  recommended: string;
  recommendedJobs: string;
  isRecommendedJobsOnResult: boolean;
}

interface DescriptionMasterV2Props {
  detectJobCardClick: (data: DetectJobCardClick) => void;
  viewedJob: (data: ViewedJob) => void;
  t: TFunction<"translation", undefined>;
  atsBullhornCandidateId: string;
  bhId: string;
  fetchRecommendedJobs: (data: RecommendedJobsData, nav?: string) => void;
  recommended: string;
  recommendedJobs: string;
  isRecommendedJobsOnResult: boolean;
  isRecommended: boolean;
  similarJobsCarouselItems: string[];
  similarJobs:SimilarJobs | null;
  similarJobsLoading:boolean;
  collaboratedJobsLoading:boolean;
  collaboratedJobs:CollaboratedJobs | null;
  collaboratedJobsCarouselItems: string[];
  onboardingInfo: OnboardingInfo;
  jobsSource: RecommendedJobsSourceTypes;
}

function DescriptionMasterV2(props: DescriptionMasterV2Props) {
  const history = useHistory();
  const [query, setQuery] = useState(new URLSearchParams(history.location.search));
  const [jobId, setJobId] = useState(query.get("jobId") || "");
  const [companyId, setCompanyId] = useState(query.get("companyId") || "");
  const [isRecommended, setIsRecommended] = useState(query.get("isRecommended") === "true");
  const [campaignCode, setCampaignCode] = useState(query.get("campaignCode") || "");
  const [sourceType, setSourceType] = useState(query.get("sourceType") || "");
  const [jobDetails, setJobDetails] = useState<jobDetailType>();
  const [isApplied, setIsApplied] = useState<boolean>(false);
  const [imageResolutionDetails, setImageResolutionDetails] = useState("");
  const [facilityCustomContent, setFacilityCustomContent] = useState<facilityCustomContentResult[]>([])
  const [authToken, setAuthToken] = useState(getAccessToken());
  const isSimilarJobsLoading = props.similarJobsLoading;
  const isPeopleViewedJobsLoading = props.collaboratedJobsLoading;  
  const SimilarJobs = props.similarJobs?._embedded?.results?.length;
  const collaboratedJobs = props.collaboratedJobs?._embedded?.results?.length;
   const { t } = useTranslation();

  useEffect(() => {
    const candidateInformation = getCandidateInformation(props.onboardingInfo);
    const data = {
      sort: "relevant",
      companyId,
      size: config.JOB_COUNT,
      candidateId: props.atsBullhornCandidateId || props.bhId,
      candidateInformation,
    };
    props.fetchRecommendedJobs(data);
    setQuery(new URLSearchParams(history.location.search));
    const query = new URLSearchParams(history.location.search);
    setJobId(query.get("jobId") || "");
    setCompanyId(query.get("companyId") || "");
    setIsRecommended(query.get("isRecommended") === "true");
    setCampaignCode(query.get("campaignCode") || "");
    setSourceType(query.get("sourceType") || "");
    setIsApplied(query.get("isApplied") === "true");
  }, [history.location.search, props.atsBullhornCandidateId]);

  useEffect(() => {
    if(jobDetails) window.scrollTo(0, 0);
  }, [jobDetails]);

  useEffect(() => {
    setAuthToken(getAccessToken());
    updateJob();
  }, [jobId]);

  // update Facility Custom Content Based on Job Details
  useEffect(() => {
    if (
      (jobDetails !== null || jobDetails !== undefined) &&
      facilityModalApplicable &&
      jobDetails?.isCustomContentEnabled
    ) {
      updateFacilityCustomContent();
    }
  }, [jobDetails]);

  useEffect(() => {
    const jobDetailsUpdated = jobDetails;
    if (jobDetailsUpdated && query.get("isApplied") !== "null") {
      jobDetailsUpdated.isApplied = isApplied;
      setJobDetails(jobDetailsUpdated);
    }
  }, [isApplied, jobDetails]);

  useEffect(() => {
    if (jobDetails && props.onboardingInfo?.onboardingInformation && (!props.onboardingInfo?.isCredentialsLoading) ) {
      const candidateInformation = getCandidateInformation(props.onboardingInfo);
      const obj = {
        isCardClicked: true,
        job: jobDetails,
        isRecommended,
        campaignCode,
        sourceType,
        companyId,
        size: config.JOB_COUNT,
        candidateInformation,
        candidateId: props.atsBullhornCandidateId || props.bhId,
      };
      props.detectJobCardClick(obj);
      const reqObj = {
        jobId,
        userId: 2,
        action: "view",
        request: {
          isActive: true,
        },
        recommended: props.recommended,
        recommendedJobs: props.recommendedJobs,
        isRecommendedJobsOnResult: props.isRecommendedJobsOnResult,
      };
      props.viewedJob(reqObj);
    }
  }, [jobDetails, props.onboardingInfo?.onboardingInformation, props.onboardingInfo?.isCredentialsLoading]);

  useEffect(() => {
    if (jobDetails && jobDetails.imageUri) {
      setImageResolutionDetails(
        imageResolution(jobDetails.imageUri, isMobile ? "Mobile" : "Desktop", "jobDescription")
      );
    }
  }, [jobDetails]);

   const skeletonCardOptions = Array.from({ length: 4 }).map(
     (_) =>
       ({
         job: undefined,
         headerOptions: {},
         contentOptions: {},
         footerOptions: {},
       } as JobCardProps)
   );

   const jobCardOptions =
     props.similarJobs?._embedded?.results?.map(
       (job) =>
         ({
           job,
           contentOptions: {
             secondaryInfo: "similarJobs",
           },
           headerOptions: {
             chips: [...(job.priority === 9 ? [{ type: "exclusive" }] : [])],
           },
           footerOptions: {},
           campaignCode: SIMILAR_JOBS,
           sourceType: HOMEPAGE,
           jobsSource: RecommendedJobsSourceTypes.NONE,
         } as unknown as JobCardProps)
     ) ?? [];

   const skeletonCollaboratedCardOptions = Array.from({ length: 4 }).map(
     (_) =>
       ({
         job: undefined,
         headerOptions: {},
         contentOptions: {},
         footerOptions: {},
       } as JobCardProps)
   );

   const jobCollaboratedCardOptions =
     props.collaboratedJobs?._embedded?.results?.map(
       (job) =>
         ({
           job,
           contentOptions: {
             secondaryInfo: "peopleViewed",
           },
           headerOptions: {
             chips: [...(job.priority === 9 ? [{ type: "exclusive" }] : [])],
           },
           footerOptions: {},
           campaignCode: CROWD_SOURCING_JOBS,
           sourceType: HOMEPAGE,
           jobsSource: RecommendedJobsSourceTypes.NONE,
         } as unknown as JobCardProps)
     ) ?? [];

  const updateJob = async () => {
    try {
      const query = { jobId: Number(jobId) };
      const {getJob} = await request(GET_JOB_DETAILS, query,  authToken);
      if(getJob?.userMessage){
        setJobDetails(getJob?.content)
      }
    } catch (e) {
      console.error("Failed to Fetch job details by jobId", e);
      setJobDetails(undefined)
    }
  };

  // fetch facility custom content API and set the content state
  const updateFacilityCustomContent = async () => {
    try {
      const { getFacilityCustomContent } = await request(GET_FACILITY_CUSTOM_CONTENT, {
        atsFacilityId: jobDetails?.facilityId?.toString(),
      });
      if(getFacilityCustomContent?.isSuccess){
        setFacilityCustomContent(getFacilityCustomContent.results)
      }
    } catch (e) {
      console.error("Failed to Fetch Facility Custom Content", e);
    }
  };

  const result = jobDetails;
  if (result) {
    result.id = jobId;
  }
  if (result) {
    return (
      <div className="jobDetailsWrap">
        <Container fluid className="p-0">
          {jobDetails?.imageUri ? (
            <Image
              src={config.JOB_CARD_IMAGE_URI_DOMAIN + imageResolutionDetails}
              className="jobDetailsBanner"
            />
          ) : isMobile ? (
            <Image
              src={
                (config.JOB_CARD_IMAGE_URI_DOMAIN || "") + (config.JOB_CARD_DEFAULT_IMAGE_SM || "")
              }
              className="jobDetailsBanner"
            />
          ) : (
            <Image
              src={
                (config.JOB_CARD_IMAGE_URI_DOMAIN || "") + (config.JOB_CARD_DEFAULT_IMAGE_LG || "")
              }
              className="jobDetailsBanner"
            />
          )}
        </Container>
        <Container className="mainJobdetailsV2">
          <JobDetailsV2
            jobDetails={result}
            companyId={companyId}
            sourceType={sourceType}
            isRecommended={isRecommended}
            jobId={0}
            facilityCustomContent={facilityCustomContent}
            jobsSource={props.jobsSource}
          />
        </Container>

        <div>
          {SimilarJobs > 0 ? (
            <div className={clsx("main",collaboratedJobs === 0 && "similarJobsBottom" )}>
              <div className="sub">
                <div className="h2Carousel">{t("jobs.jobsCard.similarJobsTitle")}</div>

                <div className="jobSlider">
                  <JobSlider
                    jobCardOptions={isSimilarJobsLoading ? skeletonCardOptions : jobCardOptions}
                    settings={{
                      xs: {
                        swipe: !isSimilarJobsLoading,
                        dots: !isSimilarJobsLoading,
                        slidesToShow: 1,
                      },
                      sm:{
                         dots: !isSimilarJobsLoading,
                         swipe: !isSimilarJobsLoading,
                         slidesToShow: 1.5,
                         slidesToScroll: 1,
                      },
                      md: {
                        dots: !isSimilarJobsLoading,
                        nextArrow: <Image src={NewChevronRightIcon} />,
                        prevArrow: <Image src={NewChevronRightIcon} />,
                        arrows: true,
                      },
                    }}
                  />
                </div>

                <div className="jobCardList">
                  <JobCardList
                    jobCardOptions={(isSimilarJobsLoading ? skeletonCardOptions : jobCardOptions).slice(0, 4)}
                  />
                </div>
              </div>
            </div>
          ) : null}
          {collaboratedJobs > 0 ? (
            <div className="main collaboratedJobsBottom">
              <div className="sub">
                <div className="h2Carousel">{t("jobs.jobsCard.otherJobsTitle")}</div>
                <div className="jobSlider">
                  <JobSlider
                    jobCardOptions={
                      isPeopleViewedJobsLoading ? skeletonCollaboratedCardOptions : jobCollaboratedCardOptions
                    }
                    settings={{
                      xs: {
                        swipe: !isPeopleViewedJobsLoading,
                        dots: !isPeopleViewedJobsLoading,
                        slidesToShow: 1,
                      },
                      sm:{
                         dots: !isPeopleViewedJobsLoading,
                         swipe: !isPeopleViewedJobsLoading,
                         slidesToShow: 1.5,
                         slidesToScroll: 1,
                      },
                      md: {
                        dots: !isPeopleViewedJobsLoading,
                        nextArrow: <Image src={NewChevronRightIcon} />,
                        prevArrow: <Image src={NewChevronRightIcon} />,
                        arrows: true,
                      },
                    }}
                  />
                </div>
                <div className="jobCardList">
                  <JobCardList
                    jobCardOptions={(isPeopleViewedJobsLoading
                      ? skeletonCollaboratedCardOptions
                      : jobCollaboratedCardOptions
                    ).slice(0, 4)}
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
  return (
    <div>
      <Banner />
    </div>
  );
}

const mapStateToProps = (state) => ({
  similarJobsCarouselItems: state.jobDetails.similarJobsCarouselItems,
  collaboratedJobsCarouselItems: state.jobDetails.collaboratedJobsCarouselItems,
  recommendedJobs: state.jobs.recommendedJobs,
  atsBullhornCandidateId: state.candidate.atsBullhornCandidateId,
  bhId: state.candidate.bullhornIdFromBullhorn,
  onboardingInfo: state.onBoarding,
  similarJobs:state.jobDetails.similarJobs,
  collaboratedJobs:state.jobDetails.collaboratedJobs,
  similarJobsLoading:state.jobDetails.similarJobsLoading,
  collaboratedJobsLoading:state.jobDetails.collaboratedJobsLoading,

});

const mapDispatchToProps = (dispatch) => ({
  viewedJob: (reqObj) => dispatch(postJobApplicationFavoriteEmail(reqObj)),
  detectJobCardClick: (obj) => dispatch(detectJobCardClick(obj)),
  fetchRecommendedJobs: (obj, nav) => dispatch(fetchRecommendedJobs(obj, nav)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DescriptionMasterV2));
